import { render, staticRenderFns } from "./analysisBarChart.vue?vue&type=template&id=97a0b8c8&scoped=true"
import script from "./analysisBarChart.vue?vue&type=script&lang=js"
export * from "./analysisBarChart.vue?vue&type=script&lang=js"
import style0 from "./analysisBarChart.vue?vue&type=style&index=0&id=97a0b8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a0b8c8",
  null
  
)

export default component.exports